<template>
  <div class="main">
    <input id="id" value="${id}" type="hidden">
		<div class="header" >
				<div class="header_title">
						<div id="pointOne_cont"  >
								<div  class="title">
										<h2 class="header_title1">{{pointOne_cont.title}}</h2>
										<span class="header_title2">{{pointOne_cont.remark}}</span>
								</div>
						</div>
						<div class="header_title3 " id="pointTow_cont" v-if="pointTow_cont.content">
								<div class="title">
										<h2>{{pointTow_cont.title}}</h2>
								</div>
						</div>
				</div>
		</div>
		<div class="content_tt">
			<div class="coupon">
				<span @click="goto(item)" v-for="(item,index) in coupon.content" :key="index" href=""><img style="width:300px;height:200px;" :src="item.pic"/></span>
			</div> 
			<div class="goods" id="shopWindow_1_cont" style="height:2550px;" v-if="shopWindow_1_cont.content">
					<div class="title">
							<h2>{{shopWindow_1_cont.title}}</h2>
					</div>
					<div class="goods_img">
							<div class="goods1" v-for="(imgLits,index) in shopWindow_1_cont.content" :key="index">
									<a ><img data-idx="index" :data-status="imgLits.status" :src="imgLits.pic" @click="goto(imgLits)" ></a>
							</div>
					</div>
			</div>
			<div class="goods goods_tow" id="shopWindow2" v-if="shopWindow2.content">
					<div class="title">
							<h2>{{shopWindow2.title}}</h2>
					</div>
					<div class="goods_img" >
							<div class="goods_tow_goods1" v-for="(imgLits,index) in shopWindow2.content" :key="index">
									<a href=""><img data-idx="index" :data-status="imgLits.status" :src="imgLits.pic" @click="goto(imgLits)"></a>
							</div>
						
					</div>
			</div>
			<div class="goods goods_tow" id="shopWindow2Cope1" v-if="shopWindow2Cope1.content">
					<div class="title">
							<h2>{{shopWindow2Cope1.title}}</h2>
					</div>
					<div class="goods_img" >
							<div class="goods_tow_goods1" v-for="(imgLits,index) in shopWindow2Cope1.content" :key="index">
									<a href=""><img data-idx="index" :data-status="imgLits.status" :src="imgLits.pic" @click="goto(imgLits)"></a>
							</div>
						
					</div>
			</div>
			<div class="goods goods_tow" id="shopWindow2Cope2" v-if="shopWindow2Cope2.content">
					<div class="title">
							<h2>{{shopWindow2Cope2.title}}</h2>
					</div>
					<div class="goods_img" >
							<div class="goods_tow_goods1" v-for="(imgLits,index) in shopWindow2Cope2.content" :key="index">
									<a href=""><img data-idx="index" :data-status="imgLits.status" :src="imgLits.pic" @click="goto(imgLits)"></a>
							</div>
						
					</div>
			</div>
			<div class="address" id="address">
				<div class="address_img">
					<img @click="goto(item)" v-for="(item,index) in address.content" :key="index" :src="item.pic"/>
				</div>
			</div>
		</div>
</div>
</template>
<script>
	import axios from 'axios'
	import Qs from 'qs'
	import { ip , overtime } from '../../assets/js/public.js'
	import bus from '../../assets/js/eventBus'
	export default {
		name: "project",
		data(){
			return {
					pointOne_cont:[],
					pointTow_cont:[],
					shopWindow_1_cont:[],
					shopWindow2:[],
					shopWindow2Cope1:[],
					shopWindow2Cope2:[],
					coupon:[],
					address:[],
					areaid:"2",

			}
		},
		mounted:function(){
			this.getProject()
		},
		methods:{
			goto:function(obj){
				var t_=this
				if( obj.status==1 ){
					if(obj.atriceId=='')return
					var href=this.$router.resolve({
						name:'articleList',
						query:{
							id:obj.atriceId
						}
					})
					window.open(href.href,'_blank')
				}else if(obj.status==2){
					var href=this.$router.resolve({
						name:'goodslist',
						query: {
							id: obj.categoryId
						}
					})
					window.open(href.href,'_blank')
				}else if(obj.status==3){
					var href=this.$router.resolve({
						name:'goodslist',
						query: {
							txt: obj.search
						}
					})
					window.open(href.href,'_blank')
				}else if(obj.status==5){
					window.open(obj.link)
				}else if(obj.status==6){
					var href=t_.$router.resolve({
						name:'goodsdetails',
						query:{
							goodsId:obj.goodsId,
							isSupplyChainGoods:2,
							supplyChainTenantId:obj.supplyChainTenantId
						}
					})
					window.open(href.href,'_blank')
				}else if(obj.status==9){
					if(obj.module==1){
						var href=this.$router.resolve({name:'teamGoods'});
						window.open(href.href,'_blank')
					}else if(obj.module==3){
						var href=this.$router.resolve({name:'couponList'});
						window.open(href.href,'_blank')
					}else if(obj.module==5){
						var href=this.$router.resolve({name:'activityList'});
						window.open(href.href,'_blank')
					}else if(obj.module==6){
						var href=this.$router.resolve({name:'scoreChange'});
						window.open(href.href,'_blank')
					}
				}
			},
			getProject:function(){
				// var t_=this
				const url = `${ip}formWorkInterface/getProject`;
				let data = Qs.stringify({
					channel:2,
					id:this.$route.query.id,
					tamp:localStorage.tamp?localStorage.tamp:''
				});
				axios.post(url, data).then(res=>{
					if(overtime(res.data.code)){
						localStorage.removeItem('tamp')
						localStorage.removeItem('name')
						return this.$router.push({
							path: '/LoginHome?state=1',
							query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
						});
						this.$router.go(0);
					}
					if(res.data.code==300){
						var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
						return window.open(href.href,'_blank')
					}

					var _data = res.data.results;
					var _this = this;
					for(var i = 0;i<_data.length;i++){
						if( _data[i].parentName == "pointOne_cont" ){
							_this.pointOne_cont = _data[i];
						}else if(_data[i].parentName == "pointTow_cont"){
							_this.pointTow_cont = _data[i];
						}else if( _data[i].parentName == "shopWindow_1_cont" ){
							_this.shopWindow_1_cont = _data[i];
						}else if( _data[i].parentName == "shopWindow2" ){
							_this.shopWindow2 = _data[i];
						}else if(_data[i].parentName == "shopWindow2Cope1"){
							_this.shopWindow2Cope1 = _data[i]
						}else if(_data[i].parentName == "shopWindow2Cope2"){
							_this.shopWindow2Cope2 = _data[i]
						}else if(_data[i].parentName == "coupon"){
							_this.coupon = _data[i]
						}else if(_data[i].parentName == "address"){
							_this.address = _data[i]
						}
					}
				}).catch(err =>{
				})
			}
		}
	}
</script>
<style>
/* *{ margin:0 auto;} */
html { -webkit-text-size-adjust:none; }
body{margin:0 auto; padding:0  ; font-family: "微软雅黑";}
ul,ul li{ margin:0; padding:0; list-style-type:none;}
.left{ float:left;}
.right{ float:right;}
.clear{ clear:both;}
a{text-decoration:none;}
img{border: 0; }
html, body {
    height: 100%;
}
input,fieldset,textarea{
    margin:0;
    padding:0;
    background:none;
    border:none;
    vertical-align:top;
    resize:none;
}
input{
    outline:none;
    float:left;
}
.main {
    width: 100%;
    min-height: 2000px;
		 background: url(../../assets/img/project/baby11_bg.png) repeat-y center center; 
		 }
/*以上为公用样式*/
.header{
    text-align: center;
    height: 1179px;
    width: 100%;
     background: url(../../assets/img/project/baby11_top.png) no-repeat center center; 
}
.header_title{
    width: 640px;
    display: inline-block;
    margin-top: 490px;
    position: relative;
    color: #fff;

}
.header_title1{
    font-size: 40px;
    color: #fff;
}
.header_title2{
    font-size: 28px;
    margin-top: 8px;
    display: inline-block;
}
.header_title3 h2{
    margin-top: 126px;
    font-size: 48px;
    text-shadow:5px 2px 6px #530277;
    color: #fff;
}
/*以上头部广告*/
.content_tt{
    text-align: center;
    /*height: 2142px;*/
    width: 100%;
     background: url(../../assets/img/project/baby11_center.png) no-repeat top center; 
}

.coupon{
    text-align: center;
    display: inline-block;
    height: 200px;
    width: 1100px;
}
.coupon span{
    display: inline-block;
    width:300px ;
    height:200px ;
    margin-right: 30px;
}
/*以上优惠券*/
.goods{
    margin-top: 60px;
    display: inline-block;
    text-align: center;
    width: 1208px;
    letter-spacing: 8px;
    position: relative;
     background: url(../../assets/img/project/goodsbg1.png) no-repeat top center; 
}
.goods .title h2{
    height: 94px;
    margin-top: 50px;
    line-height: 94px;
    color: #fff100;
    text-shadow: 5px 2px 6px #370471;
    font-size: 50px;}
.goods1{
    margin-top: 76px;
    height: 640px;
    width: 1070px;
    padding-left: 70px;
    padding-top: 70px;
}
.goods1 img{
    height: 471px;
    width: 1000px;

}
.goods1 a{cursor:pointer}
/*以上商品一层*/
#shopWindow_1_cont .goods_img div:nth-child(2),#shopWindow_1_cont .goods_img div:nth-child(3){
    margin-top: 100px;
}
.goods_tow{
    width: 1199px;
    height: 1730px;
     background: url(../../assets/img/project/goodsbg2.png) no-repeat top center; 
}
.goods_tow_goods1{
    margin-top: 76px;
    height: 530px;
    width: 500px;
    padding-top: 70px;
    display: inline-block;
	margin-right:20px;
}
.goods_tow_goods1:nth-child(2n){
	margin-right: 0;
	margin-left: 20px;
}
.goods_tow_goods1 a{ cursor: pointer;}
.goods_tow_goods1 img{
	height: 530px;
    width: 500px;
}
.goods_tow .goods_img div:nth-child(3),.goods_tow .goods_img:nth-child(4){
    margin-top: 185px;
}
/*买点一*/
#pointOne_cont{
    width: 640px;
    height: 89px;
    display: inline-block;
}
#pointOne{
    width: 640px;
    top: -1px;
    height: 85px;
    left: 0px;
}
#pointOne p{
    right: 0px;
    top: 0px;
    width: 60px;
}
/*买点二*/
#pointTow{
    width: 450px;
    height: 80px;
    top: 201px;
    left: 102px;
}
#pointTow p{
    right: 0px;
    top: 0px;
    width: 60px;
}
/*橱窗1*/
#shopWindow_1{
    width: 1200px;
    top: 0px;
    left: 0;
    height: 2510px;
}
#shopWindow_1 p{
    right: 0px;
    top: 0px;
    width: 134px;
}
/*橱窗2*/
#shopWindow2Bg,#shopWindow2Cope1Bg,#shopWindow2Cope2Bg{
    width: 1200px;
    top: 0px;
    left: 0;
    height: 1700px;
}
#shopWindow2Bg p,#shopWindow2Cope1Bg p,#shopWindow2Cope2Bg p{
    right: 0px;
    top: 0px;
    width: 364px;
}
.projectbtn{
    margin-top: 10px;
    margin-bottom: 10px;
}
.projectbtn a {
    width: 98px;
    height: 35px;
    background: #1ea4b9;
    color: #fff;
    margin-right: 10px;
    text-align: center;
    line-height: 35px;
    border-radius: 5px;
}
.content_tt .address{
    text-align: center;
    display: inline-block;
    height: 490px;
    width: 1193px;
    position: relative;
}
.content_tt .address_img img{
    width: 1193px;
    height: 419px;
 }
</style>



// WEBPACK FOOTER //
// src/components/project/index.vue